import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const contactMessageService = {
  // Tüm mesajları getir
  getMessages: async () => {
    try {
      const response = await api.get('/contact-messages');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact messages:', error);
      throw error;
    }
  },

  // Mesaj durumunu güncelle
  updateMessageStatus: async (messageId, status) => {
    try {
      const response = await api.put(`/contact-messages/${messageId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating message status:', error);
      throw error;
    }
  }
};

export default contactMessageService; 